export default {
  buildingNumber: 'No. civique',
  street: 'Rue',
  subBuilding: 'Appartement / bureau (facultatif)',
  postalBox: 'Case postale / route rurale (facultatif)',
  place: 'Succursale (facultatif)',
  city: 'Ville',
  country: 'Pays',
  province: 'Province',
  state: 'État',
  postalCode: 'Code postal',
  zipCode: 'Code ZIP',
  moreInfo: 'Succursale, casier postal ou route rurale',
};
